export const getTextFromHTML = (html: string) => {
  // First, safely remove HTML tags with a non-backtracking approach
  // This simple pattern avoids nested quantifiers that can cause catastrophic backtracking
  let result = html.replace(/<[^>]*>/g, "");

  // Decode HTML entities
  result = result
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, " ");

  // Convert line breaks to newlines with a safe approach
  // Process in two steps to avoid backtracking issues
  result = result.replace(/[ \t]*\n/g, "\n").replace(/\n[ \t]*/g, "\n");

  // Remove extra whitespace
  // Using a simple character class with a quantifier is generally safe
  result = result.replace(/[ \t\r\n\f\v]+/g, " ").trim();

  return result;
};
